<template>
  <fb-main-body class="page">
<!--    <Map style="width: 100%; height: 300px" />-->


    <div class="main-content">
      <div class="collect-box">
        <div class="collect-item">
          <span class="collect-num">{{ collectCount['recipeCount'] || 0 }}</span>
          <span>{{$t('lang.食谱总数')}}</span>
        </div>
        <div class="collect-item">
          <span class="collect-num">{{ collectCount['recipeCategoryCount'] || 0 }}</span>
          <span>{{$t('lang.食谱分类数')}}</span>
        </div>
        <div class="collect-item">
          <span class="collect-num">{{ collectCount['deviceCount'] || 0 }}</span>
          <span>{{$t('lang.设备总数')}}</span>
        </div>
        <div class="collect-item">
          <span class="collect-num">{{ collectCount['deviceOnlineCount'] || 0 }}</span>
          <span>{{$t('lang.设备在线数')}}</span>
        </div>
        <div class="collect-item">
          <span class="collect-num">{{ collectCount['activeCount'] || 0 }}</span>
          <span>{{$t('lang.设备激活数')}}</span>
        </div>
        <div class="collect-item">
          <span class="collect-num">{{ collectCount['userCount'] || 0 }}</span>
          <span>{{$t('lang.用户总数')}}</span>
        </div>
      </div>

      <div class="rank-box">

        <div class="rank-recipe">
          <span class="rank-title">{{$t('lang.最受欢迎食谱排名')}}</span>
          <div class="recipe-box">

            <div class="recipe-item" v-for="(i, index) in recipeRankList" :key="i.code">

              <el-image :src="i.photo | filterImg(that)" style="width: 70px; height: 70px" />

              <div class="recipe-desc">
                <span class="recipe-desc-t">{{ i.name }}</span>
                <div class="recipe-desc-b">
                  <span>No.{{index + 1}}</span>
                  <span>{{ i.makeCount }}次</span>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="rank-category">
          <span class="rank-title">{{$t('lang.最受欢迎分类排名')}}</span>
          <div class="category-box">
            <div class="category-item" v-for="(i, index) in categoryRankList" :key="'category' + i.number">
              <div class="rank-category-num" :style="{background: categoryNumColor[index]}">{{index + 1}}</div>
              <span>{{ i.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </fb-main-body >
</template>

<script>
import Map from "../../components/map/Map";
import {loadBrandIndexCount, loadBrandRecipeRanking, loadRecipeCategoryRanking} from "../../js/common";
export  default {
  name: 'home',
  components: {Map},
  data() {
    return {
      categoryNumColor: ['#ec0707', '#fb0c70', '#fb900c'],
      categoryRankList: [],
      recipeRankList: [],
      that: this,
      collectCount: {},
    }
  },
  async created() {
    this.categoryRankList = await loadRecipeCategoryRanking(this);
    this.recipeRankList = await loadBrandRecipeRanking(this);
    this.collectCount = await loadBrandIndexCount(this);
  }
}
</script>

<style scoped>

.page {
  height: 96%;
  display: flex;
  flex-direction: column;
}

.main-content{
  flex: 1;
  /*height: 340px;*/
  overflow: auto;
  margin-top: 34px;
}


.collect-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  box-sizing: border-box;
  padding: 0 0 34px;
}

.collect-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
}

.collect-num {
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 6px;
}

.rank-box {
  display: flex;
  margin-top: 32px;
}

.rank-recipe {
  width: 500px;
}

.rank-category {
  flex: 1;
  margin-left: 160px;
}

.rank-title {
  font-size: 24px;
  font-weight: 600;
}

.recipe-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 24px;
}

.recipe-item {
  display: flex;
  margin-bottom: 14px;
}

.recipe-desc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 12px;
  width: 130px;
  box-sizing: border-box;
  padding: 6px 0;
}

.recipe-desc-t {
  font-weight: 600;
}

.recipe-desc-b {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}

.category-box {
  margin-top: 24px;
}

.category-item {
  display: flex;
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.rank-category-num {
  width: 26px;
  height: 26px;
  background: #aeadad;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  margin-right: 14px;
}

</style>
